var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.75073H2.75C2.38533 4.75073 2.03559 4.8956 1.77773 5.15346C1.51987 5.41132 1.375 5.76106 1.375 6.12573V17.1257C1.375 17.4904 1.51987 17.8401 1.77773 18.098C2.03559 18.3559 2.38533 18.5007 2.75 18.5007H19.25C19.6147 18.5007 19.9644 18.3559 20.2223 18.098C20.4801 17.8401 20.625 17.4904 20.625 17.1257V6.12573C20.625 5.76106 20.4801 5.41132 20.2223 5.15346C19.9644 4.8956 19.6147 4.75073 19.25 4.75073ZM17.7375 6.12573L11 10.787L4.2625 6.12573H17.7375ZM2.75 17.1257V6.75136L10.6081 12.1895C10.7232 12.2693 10.8599 12.3121 11 12.3121C11.1401 12.3121 11.2768 12.2693 11.3919 12.1895L19.25 6.75136V17.1257H2.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ebf8a0810d6987835aadfb515c153e7d.svg";
export { ForwardRef as ReactComponent };